<div class="content-cell">
    <kve-editor-input-header [title]="title" [toolTip]="toolTip"></kve-editor-input-header>
    <div class="content-cell">
        
    </div>
</div>
